export const recipientMessagesEstablishmentDefaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Método', value: 'method' },
  { label: 'Estabelecimento', value: 'company' },
  { label: 'Assunto', value: 'subject' },
  { label: 'Data e hora de envio', value: 'sent_at' },
];
